export enum FeatureFlags {
  PWA = 'PWA',
}
